import React from 'react';
import PropTypes from 'prop-types';
import { composeLocationText } from '../../../utils/formatters';
import { generateImageSource } from '../../../utils/generateImageSource';

const LocationView = ({ zipCode, city, state }) => (zipCode || city || state) && (
  <span
    className="p2p-location-info__location"
    aria-label="location"
    data-testid="location-view"
  >
    <img
      src={generateImageSource('/images/v1/path-to-pro/location-icon.svg')}
      className="p2p-location-info__location-icon"
      alt="location"
    />
    {composeLocationText(zipCode, city, state)}
  </span>
);

LocationView.propTypes = {
  zipCode: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string
};

LocationView.defaultProps = {
  zipCode: '',
  city: '',
  state: ''
};

export default LocationView;
